import React, { useState } from "react";
import PropTypes from "prop-types";
import Deposit from "../../../pages/Staking/components/Deposit";
import Withdraw from "../../../pages/Staking/components/Withdraw";

import { TabsRound } from "@airdao/ui-library";

const CollapsedContentTabs = ({ poolInfo }) => {
  const [tab, setTab] = useState("Stake");

  return (
    <>
      <TabsRound
        tabsList={["Stake", "Withdraw"]}
        onChange={setTab}
        className="pool__switch"
      />
      {tab === "Stake" ? <Deposit depositInfo={poolInfo} /> : null}
      {tab === "Withdraw" ? <Withdraw withdrawContractInfo={poolInfo} /> : null}
    </>
  );
};

CollapsedContentTabs.propTypes = {
  poolInfo: PropTypes.object,
};

export default React.memo(CollapsedContentTabs);
